export const isLocalDevelopment = () => {
  const hostname = window.location.hostname;

  return (
    hostname.includes('localhost') ||
    hostname.includes('dev.ci') ||
    hostname.includes('127.0.0.1') ||
    hostname.includes('webshop-engine.sandbox.turnit.tech') ||
    hostname.includes('webshop-engine.demos.sandbox-brazil.turnit.tech')
  );
};
